import MessagingColor from './MessagingColour.svg';
import MessagingDark from './MessagingDark.svg';
import MessagingLight from './MessagingLight.svg';
export const messaging = { color: MessagingColor, dark: MessagingDark, light: MessagingLight };
//# sourceMappingURL=index.js.map